/**
 * Shop view of EmotionHeader
 */
var $ = require('jquery');

module.exports = function (_super) {

		/***************************************************************/
		// VIEW SETUP
		/***************************************************************/

		// identify this view publicly
		this.tabElementId = 'eh-shop';

		/***************************************************************/
		// INTERNAL VARIABLES
		/***************************************************************/

		// internal variables for this view
		var _theView = this, // deep self-reference
			_MODEL = _super.model, // reference the storage model
			_groupCarouselEl = null, // element where group buttons carousel is
			_colorsCarouselEl = null, // element where colors buttons carousel is
            _shopButtonsData = null, // data for all button images and groups
			_shopButtonPath = '', // the actual icon full path
			_$horSlider = null, // reference to the horizontal slider
			_$vertSlider = null, // reference to the vertical slider
			_$fieldset = null, // reference to the fieldset element
			_prevColorButtonGroupId = null, // track group changes for color button purposes
			_prevGroupId = null // track group changes for group purposes
		;

		/***************************************************************/
		// INITIALIZATION METHOD
		/***************************************************************/

		// this is called once, after the view HTML is first loaded
		this.init = function () {
		    var dataEl = $('script.eh-shop-images', _theView.viewWrapper)
		    _shopButtonsData = jQuery.parseJSON(dataEl.html());
		    // determine the icon images path, which is the same for all button icons
		    _shopButtonPath = dataEl.attr('data-baseurl');
			// save current group setting
            _prevColorButtonGroupId = _MODEL.get('shopGroupId');
            _prevGroupId = _MODEL.get('shopGroupId');
            _createTabs();
            _createGroupsCarousel();
            _createColorsCarousel();
            
			_hookShopShowButton();
			
			_createSliders();
		};

		/***************************************************************/
		// CLEANUP METHOD
		/***************************************************************/

		// called when the view is unloaded
		this.destroy = function () {
			//TODO: remove all controls
		};

		/***************************************************************/
		// CONTROLS UPDATE METHOD
		/***************************************************************/

		// called whenever a setting is changed, in any view
		this.updateView = function (foo, bar, changed, extra) {

			// tab interface visibility toggle
			// depending on whether there are products or not
			if (typeof(changed['shopHasProducts']) != 'undefined') {
			    if (1 != changed['shopHasProducts']) {
			        _$fieldset.fieldset('setCollapsed', true);
			        _$fieldset.fieldset('setDisabled', true);
    			    $('#shop-nocart-container').show();
    			    var warningContent = $('#shop-nocart-container').html();
    			    $('#shop-nocart-container').html('');
    			    $("#shop-nocart-container").diy_simpleTooltip({
    		            positionMode: 'static',
    		            content: warningContent,
    		            triggerMode: 'none',
    		            appendTo: "#shop-nocart-container",
    		            'cls': 'diy-alert-tooltip diy-error-tooltip diy-icon-tooltip diy-warning-tooltip',
    		            'contentIcon': 'ui-icon-alert'
    		        });
    			    $("#shop-nocart-container").diy_simpleTooltip('show');
    			    $('#shop-nocart-container .shop-nocart-action-link').click(function(){
    			        diy.editor.deeplinking.init({
    			            deepLinkCategory: 'admin',
    			            deepLinkItem: 'elements',
    			            deepLinkParams: {
    			                category: 'presentation_sales',
    			                scrollTo: 'product_presentation'
    			            }
    			        });
    			    });
    			}
    			else {
                    if (1 == _MODEL.get('shopShowButton')) {
                        _$fieldset.fieldset('setCollapsed', false);
                    }
                    _$fieldset.fieldset('setDisabled', false);
                    $('#shop-nocart-container').hide();
                    _theView.viewWrapper.find('.diy-carousel')
                        .diy_carousel('refresh');
    			}
			}

			// examine each changed setting
		    for (var option in changed) {
		    	// grab the new value
		        var value = changed[option];
		        // handle options
		        switch (option) {

		        	// checkbox to show or hide the button
			        case 'shopShowButton':
                        var show = 1 == value && 1 == _MODEL.get('shopHasProducts');
			            _$fieldset.fieldset('setCollapsed', !show);
			            if (show) {
			                _theView.viewWrapper.find('.diy-carousel')
			                    .diy_carousel('refresh');
			            }
		        	break;

		        	// button group selector
			        case 'shopGroupId':
    					// mark selected the icon for this group
			            var groupIndex, group, i, colorIndex, shopId;
			            for(i = 0; i < _shopButtonsData.length; i ++) {
			                if (_shopButtonsData[i]['groupId'] ==  value) {
			                    groupIndex = i;
			                    group = _shopButtonsData[i];
			                    break;
			                }
			            }
			            _groupCarouselEl.diy_carousel('selectItem', groupIndex, true /*silent*/);
			            _colorsCarouselEl.diy_carousel('option', 'items', group['images']);
                        // load color buttons for this group
                        if (extra && extra['selectFirst']) {
                            colorIndex = 0;
                        } else {
                            shopId = _MODEL.get('shopId');
                            for(i = 0; i < group['images'].length; i ++) {
                                if (group['images'][i] == shopId) {
                                    colorIndex = i;
                                    break;
                                }
                            }
                        }
                        if (colorIndex !== undefined) {
                            _colorsCarouselEl.diy_carousel('selectItem', colorIndex);
                        }
                        
                        // if group changed
                        if (value != _prevColorButtonGroupId) {
                            // set positioning settings
                            _MODEL.set({
                                'shopCssStyle': group['css'],
                                'shopHorPos': -1,
                                'shopVertPos': -1
                            });
                            // force-update sliders
                            _updateHorSlider(-1);
                            _updateVertSlider(-1);
                        } else {
                            // should be the initial updateView
                            _groupCarouselEl.diy_carousel('scrollToItem', groupIndex);
                        }
                        // save current group for next comparison
                        _prevColorButtonGroupId = value;                        
		        	break;

		        	// button icon selector
			        case 'shopId':
			            var colorsItems = _colorsCarouselEl.diy_carousel('getItems'), 
			                i, itemIndex;
			            for(i = 0; i < colorsItems.length; i ++) {
                            if (colorsItems[i] == value) {
                                itemIndex = i;
                                break;
                            }
                        }
			            if (itemIndex !== undefined) {
			                _colorsCarouselEl.diy_carousel('selectItem', itemIndex, true /*silent*/);
			            }
		        	break;

		        	// horizontal positioning slider
			        case 'shopHorPos':
						//TODO: enable/disable slider when button bigger than header
			            _updateHorSlider(value);
		        	break;

		        	// vertical positioning slider
			        case 'shopVertPos':
						//TODO: enable/disable slider when button bigger than header
                        _updateVertSlider(value);
		        	break;
		        }
		    }
		};
		
		this.onShow = function()
	    {
		    if (_theView.viewWrapper) {
		        _theView.viewWrapper.find('.diy-carousel').diy_carousel('refresh');
		    }
	    };
		
		var _createTabs = function () {
		    _theView.viewWrapper.find('.eh-shop-content').diy_simpleTabs({
                activeTabCls: 'diy-tabs-item-selected ui-icon-hover',
                tabChange: function(e, data) {
                    data.contentEl.find('.diy-carousel').diy_carousel('refresh');
                }
            });
		};
		
		var _createGroupsCarousel = function () {
            var images = [], i;
            for (i = 0; i < _shopButtonsData.length; i ++) {
                images.push({
                    image: _shopButtonsData[i]['images'][0], // first image in the group
                    groupId: _shopButtonsData[i]['groupId']
                });
            }
            _groupCarouselEl = _theView.viewWrapper.find('.eh-shop-button-section .eh-shop-thumbs'); 
            _groupCarouselEl.diy_carousel({
                items: images,
                itemTemplate: '<img src="' + _shopButtonPath + '{image}">',
                selectable: true,
                afterItemSelect: function(event, data) {
                    var gId = parseInt(data.item.groupId);
                    _MODEL.set('shopGroupId', gId, true,
                        {'selectFirst': (_prevGroupId != gId ? true : false)});
                    _prevGroupId = gId;
                },
            });
            _super.bind('open', function(){
                _groupCarouselEl.diy_carousel('refresh');
            });
		};
		
		var _createColorsCarousel = function() {
		    _colorsCarouselEl = _theView.viewWrapper.find('.eh-shop-color-section .eh-shop-thumbs'); 
		    _colorsCarouselEl.diy_carousel({
                items: [], // initially there are no items, they will be added later 
                itemTemplate: '<img src="' + _shopButtonPath + '{0}">',
                selectable: true,
                afterItemSelect: function(event, data) {
                    _MODEL.set({
                        'shopId': data.item
                    });
                },
            });
		    _super.bind('open', function(){
		        _colorsCarouselEl.diy_carousel('refresh');
            });
		}

		/***************************************************************/
		// SLIDER HELPERS AND HOOK HANDLERS
		/***************************************************************/

		// create sliders
		var _createSliders = function () {
			_$horSlider = $('#shop-position-h-slider', _super.$eheContent)
				.diy_slider({
					step:0.01,
					max: 100,
					tipText: function (value) {
						return value + '%';
					},
					slide: function (e, ui) {
                        if (!e.originalEvent) return;
                        _MODEL.set('shopHorPos', ui.value);
                    }
				}) // make the object into a slider
			;
			_$vertSlider = $('#shop-position-v-slider', _super.$eheContent)
				.diy_slider({
					step:0.01,
					max: 100,
					tipText: function (value) {
						return value + '%';
					},
					slide: function (e, ui) {
                        if (!e.originalEvent) return;
                        // XXX we use 100 - ui.value to invert the slider value
                        _MODEL.set('shopVertPos', 100 - ui.value);
                    }
				}) // make the object into a slider
			;
		};

        // horizontal slider update helper
        var _updateHorSlider = function (value) {
            // sanity check for when preview is off
            if ('undefined' == typeof(CC.EmotionHeader.Preview)) {
                return;
            }
            // if value is "default"
            if (-1 == value) {
                // read percentage from the button
                var perc = CC.EmotionHeader.Preview
                    .shopButtonSliderPosition().left;
            } else {
                // otherwise, percentage is the indicated value
                var perc = value;
            }
            // set the slider
            _setSlider(_$horSlider, 'shop-position-h-slider', perc);
        };

        // vertical slider update helper
        var _updateVertSlider = function (value) {
            // sanity check for when preview is off
            if ('undefined' == typeof(CC.EmotionHeader.Preview)) {
                return;
            }
            // if value is "default"
            if (-1 == value) {
                // read percentage from the button
                var perc = CC.EmotionHeader.Preview
                    .shopButtonSliderPosition().top;
            } else {
                // otherwise, percentage is the indicated value
                var perc = value;
            }
            // set the slider
            // XXX we use 100 - perc to invert the slider value
            _setSlider(_$vertSlider, 'shop-position-v-slider', 100 - perc);
        };

		// set given slide object to certain value
		var _setSlider = function (slideObject, slideId, value) {
			slideObject.diy_slider('value', value);
		};

		/***************************************************************/
		// GROUP AND COLOR BUTTONS HOOKS AND HANDLERS
		/***************************************************************/

		// hook click event on the show button checkbox
		var _hookShopShowButton = function () {
		    _$fieldset = $('.eh-shop-content .fieldset', _super.$eheContent);
		    _$fieldset.fieldset({ collapsed: true });
	        _$fieldset.bind('toggle.fieldset', function(e, show) {
	            _MODEL.setShopShowButton(show ? 1 : 0);
	            $(document).trigger('diy-eh-component-visibility-changed', {
	                'componentName': 'shop',
	                'show': show
	            });
	        });
		};

	}; // end of view definition



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/emotion-header/CC.EmotionHeader.Shop.js
 ** module id = 872
 ** module chunks = 0
 **/